import classNames from 'classnames';

import { type IconComponent, SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

import styles from './CellIcon.module.scss';

interface CellIconProps {
    icon: IconComponent;
    /** 12 px for the second line and pills, 14 px otherwise. */
    size?: 'small' | 'medium';
    /** Colour, since the icon is painted in the text colour, or a size a context must force. */
    className?: string;
}

/** An audit-log glyph sized to the cell text and painted in its colour. */
export default function CellIcon({ icon, size = 'medium', className }: CellIconProps) {
    return (
        <SvgIcon
            icon={icon}
            className={classNames(styles.icon, styles[size], className)}
            svgProps={{ 'aria-hidden': true }}
        />
    );
}
